import type { CourseDetailsAuthorDisplay } from '../entities/course-details.entity'

/**
 * Провайдер фейковых данных для страницы деталей курса (пока нет в API).
 */

export const courseDetailsFakeLearningObjectives: string[] = []

export const courseDetailsFakeAuthor: CourseDetailsAuthorDisplay = {
  name: 'John Doe',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
  designation: 'Senior Full-Stack Developer, Topylo',
  rating: 4.9,
  reviewsCount: 120,
  stats: { courses: 5, students: 105624 },
  socialLinks: [
    { url: '#', icon: 'fa-brands fa-facebook-f' },
    { url: '#', icon: 'fa-brands fa-x-twitter' },
    { url: '#', icon: 'fa-brands fa-linkedin-in' },
    { url: '#', icon: 'fa-brands fa-instagram' },
    { url: '#', icon: 'fa-brands fa-behance' },
  ],
  description:
    'With over 10 years of experience in web development, I have contributed to various projects ranging from small business websites to complex enterprise applications. As a Senior Full-Stack Developer at Topylo, I specialize in creating seamless user experiences using modern web technologies such as React, Node.js, and Tailwind CSS. My goal is to help you master the skills needed to succeed in the tech industry.',
  profileUrl: '#',
}
